import axiosInstance from '../axiosInstance';

// Listado con búsqueda/paginación/estado
export const fetchSystemVehicles = async ({ q = '', page = 0, limit = 10, estreg } = {}) => {
    // backend espera page 1-based; DataGrid usa 0-based
    const params = { q, page: page + 1, limit };
    if (estreg) params.estreg = estreg;

    const { data } = await axiosInstance.get('/maintenance/systemVehicle', { params });
    // data esperado: { page, limit, total, items }
    return data;
};

// Crear
export const createSystemVehicle = async (payload) => {
    const { data } = await axiosInstance.post('/maintenance/systemVehicle', payload);
    return data;
};

// Update
export const updateSystemVehicle = async (id, payload) => {
    const { data } = await axiosInstance.put(`/maintenance/systemVehicle/${id}`, payload);
    return data;
};

// Delete (lógico EstReg='E' en backend, usa req.user.EmpID)
export const deleteSystemVehicle = async (id) => {
    const { data } = await axiosInstance.delete(`/maintenance/systemVehicle/${id}`);
    return data;
};

// Obtener uno
export const fetchSystemVehicleById = async (id) => {
    const { data } = await axiosInstance.get(`/maintenance/systemVehicle/${id}`);
    return data;
};

export const fetchSystemVehicleOptions = async ({ q = '', limit = 20 } = {}) => {
    const params = { q, page: 1, limit, estreg: 'A' };
    const { data } = await axiosInstance.get('/maintenance/systemVehicle', { params });
    // data esperado: { page, limit, total, items }
    return data.items || [];
};
